import React from 'react';

import SideNav from './SideNav';

const UserProfile = ({ goToPage, curPath, logout }) => {
    return (
        <div className="border-t border-gray-200 p-4 mt-auto">
            <div className="space-y-3">
                {/* User Info */}
                <div className="flex items-center px-3 py-2">
                    <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-medium">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                        </svg>
                    </div>
                    <div className="ml-3">
                        <p className="text-sm font-medium text-gray-900">User</p>
                        <p className="text-xs text-gray-500">Member</p>
                    </div>
                </div>

                {/* Profile Menu Items using SideNav */}
                <div className="space-y-1">
                    <SideNav name="Profile" route="/member/profile" goToPage={goToPage} curPath={curPath} />

                    <SideNav
                        name="Change Password"
                        route="/member/change-password"
                        goToPage={goToPage}
                        curPath={curPath}
                    />

                    {/* Custom Logout Button to maintain red styling */}
                    <div
                        className="w-full px-4 py-3 text-sm font-medium rounded-lg cursor-pointer transition-all duration-200 text-red-600 hover:bg-red-50 active:bg-red-50 touch-manipulation"
                        onClick={logout}
                    >
                        Logout
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserProfile;
